import React from "react";

const MaintenanceMode = () => {
  const renderLogos = () => (
    <React.Fragment>
      <img
        height="100px"
        src="https://s3.ap-southeast-2.amazonaws.com/cdn.fashionbiz.com/webstore/Fashion+Biz+Logo.png"
        alt="fashion biz logo"
      />
    </React.Fragment>
  );
  return (
    <div className="maintenance-page">
      <div className="main-content">
        <div className="logos-section">{renderLogos()}</div>
        <div className="maintenance-img">
          <img
            src="https://s3.ap-southeast-2.amazonaws.com/cdn.fashionbiz.com/webstore/Web-Store-Maintenance-Mode.jpg"
            width={"100%"}
            height={"100%"}
          />
        </div>
      </div>
    </div>
  );
};

export default MaintenanceMode;
